import { CanDeactivateFn } from '@angular/router';
import { DeactivatableComponent } from './deactivatable.component.interface';

/** Our Route Guard as a Function */
export const canDeactivateFormComponent: CanDeactivateFn<DeactivatableComponent> = (component: DeactivatableComponent) => {
  if (component.canDeactivate) {
    return component.canDeactivate();
  }
  return true;
};
